import React from 'react';
import styled from 'styled-components';
import { Button, Form, Input, message, Typography } from 'antd';
import { SourceBuilderState, StepProps } from './types';
import { useTranslation } from '../../../../i18n/useTranslation';

const ControlsContainer = styled.div`
    gap: 8px;
    display: flex;
    margin-top: 8px;
    justify-content: space-between;
`;

const MAX_NAME_LENGTH = 120;

export const NameSourceStep = ({ state, updateState, prev, submit }: StepProps) => {
    const { t } = useTranslation();
    const setName = (stagedName: string) => {
        const newState: SourceBuilderState = {
            ...state,
            displayName: stagedName,
        };
        updateState(newState);
    };

    const onClickCreate = (shouldRun?: boolean) => {
        const parsedRecipe = JSON.parse(state.config?.recipe || '{}');
        // If we have either applianceId or (platform_instance with role), bypass the error condition
        if (
            !(
                state?.applianceId ||
                (parsedRecipe.source?.config?.platform_instance && parsedRecipe.source?.config?.role)
            )
        ) {
            const errorMessage = t('Pod or Platform Instance with Role is required in the Configure Recipe step.');
            message.error({ content: errorMessage, duration: 3 });
            return;
        }

        if (
            state.displayName !== undefined &&
            state.displayName.length > 0 &&
            state.displayName.length <= MAX_NAME_LENGTH
        ) {
            submit(shouldRun);
        }
    };
    const isValidName =
        state.displayName !== undefined && state.displayName.length > 0 && state.displayName.length <= MAX_NAME_LENGTH;

    return (
        <>
            <Form layout="vertical">
                <Form.Item
                    required
                    label={
                        <Typography.Text strong style={{ marginBottom: 0 }}>
                            <span>{t('Name')}</span>
                            <span className="f-color-risk-very-high">*</span>
                        </Typography.Text>
                    }
                    style={{ marginBottom: 24 }}
                    validateStatus={
                        state.displayName && state.displayName.length > MAX_NAME_LENGTH ? 'error' : undefined
                    }
                    help={
                        state.displayName && state.displayName.length > MAX_NAME_LENGTH
                            ? t(`Name can contain 1-{{length}} characters only`, {
                                  length: MAX_NAME_LENGTH,
                              })
                            : undefined
                    }
                >
                    <Typography.Paragraph>{t('Give this ingestion source a name.')}</Typography.Paragraph>
                    <Input
                        data-testid="source-name-input"
                        className="source-name-input"
                        placeholder={t('My Redshift Source #2')}
                        value={state.displayName}
                        onChange={(event) => setName(event.target.value)}
                    />
                </Form.Item>
            </Form>
            <ControlsContainer>
                <Button onClick={prev}>{t('Previous')}</Button>
                <Button
                    onClick={() => onClickCreate(false)}
                    data-testid="ingestion-source-save-button"
                    disabled={!isValidName}
                >
                    {t('Save')}
                </Button>
                <Button block type="primary" onClick={() => onClickCreate(true)} disabled={!isValidName}>
                    {t('Save & Run Ingestion')}
                </Button>
            </ControlsContainer>
        </>
    );
};
